export const geolocationConstants = {
    CANONICAL_NAME_FIELD: 'Canonical Name',
    NOT_AVAILABLE_VALUE: 'N/A',
};
